import { ReactComponent as RemoveRequest } from 'assets/svg/request-delete-magnet.svg';
import { ModalLayoutProps } from 'components/Modals';
import ModalLayout from 'components/Modals/ModalLayout';
import { HelloMuiButton } from 'components/Mui';

interface Props extends ModalLayoutProps {
    title?: string;
    description?: string;
    Icon?: React.FunctionComponent<
        React.SVGProps<SVGSVGElement> & {
            title?: string | undefined;
        }
    >;

    onRemove?: () => void;
}

export default function DeleteRequestModal({
    visible,
    onClose,
    title = 'Remove Saved Request?',
    description = 'Removing this saved request will delete it from your saved list permanently. This action cannot be undone.',
    Icon = RemoveRequest,
    onRemove,
}: Props) {
    return (
        <ModalLayout visible={visible} onClose={onClose} showCloseIcon={false}>
            <div className="bg-white rounded-lg px-6 pt-6 pb-3 text-center max-w-[380px]">
                <div className="flex flex-col gap-4 items-center">
                    <Icon />
                    <div>
                        <div className="font-semibold text-lg text-my-black">{title}</div>
                        <div className="text-base text-my-black/80 mt-1">{description}</div>
                    </div>
                    <div className="flex flex-col w-full">
                        <>
                            <HelloMuiButton
                                variant="contained"
                                className="!rounded-full !mb-2 !py-3"
                                onClick={() => {
                                    onRemove?.();
                                    onClose();
                                }}
                            >
                                Remove
                            </HelloMuiButton>
                            <HelloMuiButton onClick={onClose}>Cancel</HelloMuiButton>
                        </>
                    </div>
                </div>
            </div>
        </ModalLayout>
    );
}
